













import { Component, Mixins } from "vue-property-decorator";
import { ArrowKinds } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import ArrowKindDropDownSelector from "./ArrowKindDropDownSelector.vue";

@Component({
  components: {
    arrowKindSelector: ArrowKindDropDownSelector,
  },
})
export default class ArrowStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: ArrowKinds;

  get arrowKind(): ArrowKinds {
    return this.editingSource;
  }

  set arrowKind(value: ArrowKinds) {
    this.input(value);
  }
}
